<template>
  <div id="app">
    <GoogleMap/>
  </div>
</template>

<script>
import GoogleMap from './components/gMap.vue'

export default {
  name: 'App',
  components: {
    GoogleMap
  }
}
</script>
